import { IndicatorValuesDto } from './indicator-values.dto';

/**
 * Dto des indicateurs techiniques.
 */
export interface TechnicalIndicatorDto {
    //Identifiant
    id: string;
    //Valeur actuelle
    currentValue: string;
    //Historique des valeurs
    values?: IndicatorValuesDto[];
    //unitées
    unit: string;
    //Possède un document
    hasDocument: boolean;
    //Type d'indicateur
    type: TypeTechnicalIndicator;
}

/**
 * Enum pour le type d'indicateurs
 */
export enum TypeTechnicalIndicator {
    //Linéaire de réseau
    LINEARNETWORK = 'LINEARNETWORK',
    //Rendement
    EFFICIENCY = 'EFFICIENCY',
    //Volume comptabilisé
    VOLUMECOUNTED = 'VOLUMECOUNTED',
    //Volume produit
    PRODUCTVOLUME = 'PRODUCTVOLUME',
    //Volume facturé
    BILLEDVOLUME = 'BILLEDVOLUME',
    //Evolution du facturé
    EVOLUTIONBILLED = 'EVOLUTIONBILLED',
    //Comparaison entre le théorique facturé et le réel
    COMPARETHEORETICALREAL = 'COMPARETHEORETICALREAL',
    //Recette HT - redevance comprise (par exercice comptable)
    RECIPEEXCLUDINGTAX = 'RECIPEEXCLUDINGTAX',
    //Nombre d'habitants
    INHABITANTS = 'INHABITANTS',
    //Nombre d'abonnés
    SUBSCRIBERS = 'SUBSCRIBERS',
    //Linéaire de cours d'eau
    WATERCOURSELENGTH = 'WATERCOURSELENGTH',
}
